import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authFetch } from '../../Utilities/Api';
// ✅ Import path assumes Form is in components/Groups
import CreateGroupForm from '../../components/Groups/CreateGroupForm';
import './GroupsDashboard.css';

const GroupsDashboard = () => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showCreateModal, setShowCreateModal] = useState(false);
    const navigate = useNavigate();

    // 🔍 DEBUG: Log when component mounts
    useEffect(() => {
        console.log("🛠️ [GroupsDashboard] Component Mounted");
    }, []);

    const fetchGroups = async () => {
        console.log("🔄 [GroupsDashboard] fetchGroups() initiated...");
        try {
            setLoading(true);

            // ✅ UPDATED ENDPOINT: Matches your chatRoutes.js
            console.log("📡 [GroupsDashboard] GET /api/chats/my-groups");
            const res = await authFetch('/chats/my-groups');

            console.log(`📡 [GroupsDashboard] Response Status: ${res.status}`);
            const data = await res.json();

            if (!res.ok) {
                console.error("❌ [GroupsDashboard] API Error:", data);
                throw new Error(data.message || 'Failed to load groups');
            }

            console.log("✅ [GroupsDashboard] Groups loaded:", data);
            setGroups(data);
        } catch (err) {
            console.error("💥 [GroupsDashboard] Catch Error:", err);
            setError(err.message || 'Failed to load groups');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGroups();
    }, []);

    // Function to refresh list when a new group is made
    const handleGroupCreated = () => {
        console.log("✨ [GroupsDashboard] Group created successfully. Refreshing list...");
        fetchGroups();
        setShowCreateModal(false);
    };

    return (
        <div className="groups-dashboard">
            <div className="dashboard-header">
                <h1>Your Groups</h1>
                <button
                    className="btn-primary"
                    onClick={() => {
                        console.log("➕ [GroupsDashboard] 'New Group' button clicked");
                        setShowCreateModal(true);
                    }}
                >
                    + New Group
                </button>
            </div>

            {loading ? (
                <div className="spinner"></div>
            ) : error ? (
                <p className="error">{error}</p>
            ) : groups.length === 0 ? (
                <div className="empty-state">
                    <p>You are not in any groups yet.</p>
                </div>
            ) : (
                <ul className="group-list">
                    {groups.map(group => (
                        <li
                            key={group._id}
                            className="group-item"
                            onClick={() => {
                                console.log(`👉 [GroupsDashboard] Navigating to Chat: ${group._id}`);
                                navigate(`/chat/${group._id}`);
                            }}
                        >
                            <div className="group-info">
                                <strong>{group.name}</strong>
                                <span className="member-count">
                                    {group.members.length} members
                                </span>
                            </div>
                            <span className="arrow">→</span>
                        </li>
                    ))}
                </ul>
            )}

            {/* ✅ Modal Logic for Creating Group */}
            {showCreateModal && (
                <div className="modal-backdrop">
                    <div className="modal-content">
                        <button
                            className="modal-close-btn"
                            onClick={() => {
                                console.log("❌ [GroupsDashboard] Closing Modal");
                                setShowCreateModal(false);
                            }}
                        >
                            &times;
                        </button>
                        {/* Pass the success handler to the form */}
                        <CreateGroupForm onClose={handleGroupCreated} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GroupsDashboard;